export default __webpack_public_path__ + "icon-collapse-arrowe6a652.png";